import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { Formik, Form, Field, FieldArray, ErrorMessage } from 'formik';
import { Form as bootStrapForm, InputGroup, Col, Button, FormControl, Spinner } from 'react-bootstrap';
import { hideModal } from '../../actions/modalsActions';
import CyberSecurity from '../../apis/cyberSecurityData';
import ReCAPTCHA from "react-google-recaptcha";
import * as yup from 'yup';

const schema = yup.object({
    firstName: yup.string().max(600).matches(/^[ A-Za-z0-9_.&?!',-\/()]*$/, 'Only Characters and Numbers Allowed').required(),
    lastName: yup.string().max(600).matches(/^[ A-Za-z0-9_.&?!',-\/()]*$/, 'Only Characters and Numbers Allowed').required(),
    email: yup.string().matches(/^[ A-Za-z0-9_.@&?!',-\/()]*$/, 'Please enter a valid Email Address').email('Please enter a valid Email Address').required(),
    // phone: yup.string().max(20).matches(/^[0-9+-]+$/, 'Only Phone Numbers are Allowed'),
    howFoundTrukno: yup.string().required('This is Required'),
    howFoundTruknoOther: yup.string().max(50).matches(/^[ A-Za-z0-9_.@&?!',-\/()]*$/, 'Only Characters and Numbers Allowed'),
    primaryUse: yup.string().required('This is Required'),
    primaryUseOther: yup.string().max(50).matches(/^[ A-Za-z0-9_.@&?!',-\/()]*$/, 'Only Characters and Numbers Allowed'),
    navigationRate: yup.string().required('This is Required'),
    primaryBenefit: yup.string().max(600).matches(/^[ A-Za-z0-9_.@&?!',-\/()\n]*$/, 'Only Characters and Numbers Allowed').required('This is Required'),
    otherComments: yup.string().max(600).matches(/^[ A-Za-z0-9_.@&?!',-\/()\n]*$/, 'Only Characters and Numbers Allowed').required('This is Required'),
    followUpEmail: yup.string().matches(/^[ A-Za-z0-9_.@&?!',-\/()]*$/, 'Please enter a valid Email Address').email('Please enter a valid Email Address').required()
});

function GeneralFeedback(props) {
    const [updated, setUpdated] = useState(false)
    const [submitting, setSubmitting] = useState(false);
    const [recaptcha, setRecaptcha] = useState(false);
    const [viewRecaptcha, setViewRecaptcha] = useState(false);

    const renderTextField = ({ field, form, meta, checkHidden }, label) => {
        return (
            <bootStrapForm.Group>
                {/* <bootStrapForm.Label>{label}</bootStrapForm.Label> */}
                <bootStrapForm.Control isInvalid={meta.touched && meta.error} {...field} type="text" placeholder={label} />
                {meta.touched && meta.error && <div className="error" style={{ color: '#ff4040' }}>{meta.error}</div>}
            </bootStrapForm.Group>
        )
    }

    const renderTextAreaField = ({ field, form, meta }, label) => {
        return (
            <bootStrapForm.Group >
                {/* <bootStrapForm.Label>{label}</bootStrapForm.Label> */}
                <h3 style={{ fontWeight: '600' }}>{label}</h3>
                <Col className="px-0" sm={12}>
                    <bootStrapForm.Control isInvalid={meta.error} {...field} as="textarea" type="textarea" style={{ height: 100 }} />
                    {meta.touched && meta.error && <div className="error" style={{ color: '#ff4040' }}>{meta.error}</div>}
                </Col>
            </bootStrapForm.Group>
        )
    }

    const renderDropDown = ({ field, form, meta, checkHidden }, label, dropdownOptions) => {
        return (
            <bootStrapForm.Group controlId="formGrid">
                <bootStrapForm.Label>{label}</bootStrapForm.Label>
                <bootStrapForm.Control isInvalid={meta.touched && meta.error} as="select" {...field} type="select" placeholder={label}>
                    <option value="">{label}</option>
                    {dropdownOptions.map(el => <option key={el} value={el}>{el}</option>)}
                </bootStrapForm.Control>
                {meta.touched && meta.error && <span style={{ color: 'red' }}>{meta.error}</span>}
            </bootStrapForm.Group>
        )
    }

    const onRecaptchaChange = (value) => {
        setRecaptcha(value)
    }

    return (
        <Formik
            validationSchema={schema}
            // validate={values => validate(values)}
            onSubmit={async (values, { resetForm, setErrors }) => {
                if (recaptcha) {
                    if (values.howFoundTrukno === 'Other' && !values.howFoundTruknoOther) return setErrors({ howFoundTruknoOther: 'Please provide how did you find Trukno.' })
                    if (values.primaryUse === 'Other' && !values.primaryUseOther) return setErrors({ primaryUseOther: 'Please provide what is the other use.' })

                    try {
                        const response = await CyberSecurity.post('/generalfeedback', values);
                        props.hideModal()
                    } catch (error) {
                        console.log(error.message)
                    }
                }
            }}
            initialValues={{
                firstName: props.currentUser.firstName || '',
                lastName: props.currentUser.lastName || '',
                email: props.currentUser.email || '',
                phone: props.currentUser.phone || '',
                howFoundTrukno: '',
                howFoundTruknoOther: '',
                primaryUse: '',
                primaryUseOther: '',
                navigationRate: '',
                primaryBenefit: '',
                otherComments: '',
                followUpEmail: ''
            }}
        >
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
                validateField,
                isSubmitting
            }) => (
                    <Form autoComplete="off" className="px-3">
                        <div className="row">
                            <div className="col-md-6 pr-md-2">
                                <Field name="firstName">
                                    {({ field, form, meta }) => renderTextField({ field, form, meta }, 'First Name*')}
                                </Field>
                            </div>
                            <div className="col-md-6 pl-md-2">
                                <Field name="lastName">
                                    {({ field, form, meta }) => renderTextField({ field, form, meta }, 'Last Name*')}
                                </Field>
                            </div>
                        </div>

                        <Field name="email">
                            {({ field, form, meta }) => renderTextField({ field, form, meta }, 'Email*')}
                        </Field>

                        <div className="row">
                            <div className="col-md-12">
                                <Field component="div" name="howFoundTrukno">
                                    <div className="grid">
                                        <div className="row align-item-center">
                                            <div className="col">
                                                <h3 style={{ fontWeight: '600' }}>1. How did you find Trukno?</h3>
                                                <label htmlFor="radioOne-q1" className="radio-container">
                                                    Peer Referral.
                                                        <input
                                                        type="radio"
                                                        id="radioOne-q1"
                                                        // defaultChecked={values.howFoundTrukno === "none"}
                                                        name="howFoundTrukno"
                                                        value="Peer Referral"
                                                    />
                                                    <span className="radiomark"></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="d-flex">
                                                    <label htmlFor="radioTwo-q1" className="radio-container">
                                                        Linkedin.
                                                          <input
                                                            type="radio"
                                                            id="radioTwo-q1"
                                                            // defaultChecked={values.howFoundTrukno === "basic"}
                                                            name="howFoundTrukno"
                                                            value="Linkedin"
                                                        />
                                                        <span className="radiomark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="d-flex">
                                                    <label htmlFor="radioThree-q1" className="radio-container">
                                                        Press.
                                                          <input
                                                            type="radio"
                                                            id="radioThree-q1"
                                                            // defaultChecked={values.howFoundTrukno === "advanced"}
                                                            name="howFoundTrukno"
                                                            value="Press"
                                                        />
                                                        <span className="radiomark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="d-flex">
                                                    <label htmlFor="radioFour-q1" className="radio-container">
                                                        Other (Please Specify).
                                                          <input
                                                            type="radio"
                                                            id="radioFour-q1"
                                                            // defaultChecked={values.howFoundTrukno === "advanced"}
                                                            name="howFoundTrukno"
                                                            value="Other"
                                                        />
                                                        <span className="radiomark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        {touched.howFoundTrukno && errors.howFoundTrukno && <div className="error" style={{ color: 'red' }}>{errors.howFoundTrukno}</div>}
                                    </div>
                                </Field>
                            </div>
                        </div>
                        {values.howFoundTrukno === 'Other' && <Field name="howFoundTruknoOther">
                            {({ field, form, meta }) => renderTextField({ field, form, meta }, 'How did you find Trukno?*')}
                        </Field>}

                        <div className="row mt-3">
                            <div className="col-md-12">
                                <Field component="div" name="primaryUse">
                                    <div className="grid">
                                        <div className="row align-item-center">
                                            <div className="col">
                                                <h3 style={{ fontWeight: '600' }}>2. What primary function have you been using TruKno for?</h3>
                                                <label htmlFor="radioOne-q2" className="radio-container">
                                                    General Cyber Research.
                                                        <input
                                                        type="radio"
                                                        id="radioOne-q2"
                                                        // defaultChecked={values.primaryUse === "none"}
                                                        name="primaryUse"
                                                        value="General Cyber Research"
                                                    />
                                                    <span className="radiomark"></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="d-flex">
                                                    <label htmlFor="radioTwo-q2" className="radio-container">
                                                        Descovering new threats.
                                                          <input
                                                            type="radio"
                                                            id="radioTwo-q2"
                                                            // defaultChecked={values.primaryUse === "basic"}
                                                            name="primaryUse"
                                                            value="Descovering new threats"
                                                        />
                                                        <span className="radiomark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="d-flex">
                                                    <label htmlFor="radioThree-q2" className="radio-container">
                                                        Finding Innovative solutions.
                                                          <input
                                                            type="radio"
                                                            id="radioThree-q2"
                                                            // defaultChecked={values.primaryUse === "advanced"}
                                                            name="primaryUse"
                                                            value="Finding Innovative solutions"
                                                        />
                                                        <span className="radiomark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="d-flex">
                                                    <label htmlFor="radioFour-q2" className="radio-container">
                                                        Other (Please Specify).
                                                          <input
                                                            type="radio"
                                                            id="radioFour-q2"
                                                            // defaultChecked={values.primaryUse === "General industry research"}
                                                            name="primaryUse"
                                                            value="Other"
                                                        />
                                                        <span className="radiomark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        {touched.primaryUse && errors.primaryUse && <div className="error" style={{ color: 'red' }}>{errors.primaryUse}</div>}
                                    </div>
                                </Field>
                            </div>
                        </div>
                        {values.primaryUse === 'Other' && <Field name="primaryUseOther">
                            {({ field, form, meta }) => renderTextField({ field, form, meta }, 'Please explain the other use?*')}
                        </Field>}

                        <div className="row mt-3">
                            <div className="col-md-12">
                                <Field component="div" name="navigationRate">
                                    <div className="grid">
                                        <div className="row align-item-center">
                                            <div className="col">
                                                <h3 style={{ fontWeight: '600' }}>3. How would you rate your navigation experience on the site?</h3>
                                                <label htmlFor="radioOne-q3" className="radio-container">
                                                    Very easy.
                                                        <input
                                                        type="radio"
                                                        id="radioOne-q3"
                                                        // defaultChecked={values.navigationRate === "none"}
                                                        name="navigationRate"
                                                        value="Very easy"
                                                    />
                                                    <span className="radiomark"></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="d-flex">
                                                    <label htmlFor="radioTwo-q3" className="radio-container">
                                                        Somewhat easy.
                                                          <input
                                                            type="radio"
                                                            id="radioTwo-q3"
                                                            // defaultChecked={values.navigationRate === "basic"}
                                                            name="navigationRate"
                                                            value="Somewhat easy"
                                                        />
                                                        <span className="radiomark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="d-flex">
                                                    <label htmlFor="radioThree-q3" className="radio-container">
                                                        Somewhat confusing.
                                                          <input
                                                            type="radio"
                                                            id="radioThree-q3"
                                                            // defaultChecked={values.navigationRate === "advanced"}
                                                            name="navigationRate"
                                                            value="Somewhat confusing"
                                                        />
                                                        <span className="radiomark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="d-flex">
                                                    <label htmlFor="radioFour-q3" className="radio-container">
                                                        Difficult to navigate.
                                                          <input
                                                            type="radio"
                                                            id="radioFour-q3"
                                                            // defaultChecked={values.navigationRate === "advanced"}
                                                            name="navigationRate"
                                                            value="Difficult to navigate"
                                                        />
                                                        <span className="radiomark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        {touched.navigationRate && errors.navigationRate && <div className="error" style={{ color: 'red' }}>{errors.navigationRate}</div>}
                                    </div>
                                </Field>
                            </div>
                        </div>

                        <Field name="primaryBenefit">
                            {({ field, form, meta }) => renderTextAreaField({ field, form, meta }, "4. In your own words, what do you see the primary benefit of TruKno?")}
                        </Field>

                        <Field name="otherComments">
                            {({ field, form, meta }) => renderTextAreaField({ field, form, meta }, '5. Do you have any other Comments/Suggestions for us?')}
                        </Field>

                        <div className="row mt-3">
                            <div className="col-md-12">
                                <Field component="div" name="followUpEmail">
                                    <div className="grid">
                                        <div className="row align-item-center">
                                            <div className="col">
                                                <h3 style={{ fontWeight: '600' }}>6. Would you be open for a follow-up email to help make Trukno better for you?</h3>
                                                <label htmlFor="radioOne-q4" className="radio-container">
                                                    Yes.
                                                        <input
                                                        type="radio"
                                                        id="radioOne-q4"
                                                        // defaultChecked={values.followUpEmail === "none"}
                                                        name="followUpEmail"
                                                        value="Yes"
                                                    />
                                                    <span className="radiomark"></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="d-flex">
                                                    <label htmlFor="radioTwo-q4" className="radio-container">
                                                        No.
                                                          <input
                                                            type="radio"
                                                            id="radioTwo-q4"
                                                            // defaultChecked={values.followUpEmail === "basic"}
                                                            name="followUpEmail"
                                                            value="No"
                                                        />
                                                        <span className="radiomark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        {touched.followUpEmail && errors.followUpEmail && <div className="error" style={{ color: 'red' }}>{errors.followUpEmail}</div>}
                                    </div>
                                </Field>
                            </div>
                        </div>

                        <div className="d-flex flex-column justify-content-center  align-items-center pb-4">
                            {viewRecaptcha && !recaptcha && <span style={{ color: 'red' }}>Please verify that you are human</span>}

                            {viewRecaptcha && <ReCAPTCHA
                                sitekey="6Lc0_uEUAAAAAE29L9BpPI5PZMN6q2J67R4SN9Hj"
                                onChange={onRecaptchaChange}
                            />}
                            <div className="d-flex">
                                <Button variant="outline-primary" size="md" onClick={() => props.changeActiveSection('menu')} className="mt-4 mr-2">
                                    Back
                                </Button>
                                <Button variant="primary" type="submit" size="md" onClick={() => setViewRecaptcha(true)} className="mt-4">
                                    Submit
                                {submitting ? <Spinner className="ml-3" as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}
                                </Button>

                            </div>
                        </div>
                        <h3 className={`mt-3 ${updated && isValid ? null : 'd-none'}`} style={{ color: 'white' }} >Message Sent</h3>
                    </Form>
                )}
        </Formik>
    );
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser,
        accessToken: state.accessToken
    }
}

export default connect(mapStateToProps, { hideModal })(GeneralFeedback);
